export const GLACIER_API_KEY = process.env.GLACIER_API_KEY;
